import {
  Box,
  ColorOptions,
  Icon,
  IconButton,
  Loader,
  ModalDialog,
  ModBox,
  Spacer,
  Text,
  TextInputNew
} from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useEffect, useState, useTransition } from 'react'
import { TableComponent } from '../../../comps/TableComponent'
import { useLazyApiData, useStores } from '../../../data/store'
import { Colors } from '../../../util/util'

const getConsumedAmount = (data: any) => {
  let amt = 0
  data?.map((obj) => {
    amt = amt + Number(obj?.splitAmount) ?? 0
  })
  return amt
}

const RenderItem = ({
  item,
  setBeneficiaryListVisible,
  setSelectedBeneficiariesToSplit,
  selectedBeneficiaries,
  startTransition,
}: any) => {
  const onItemPress = () => {
    if (selectedBeneficiaries?.indexOf(item) === -1) {
      startTransition(() => {
        setSelectedBeneficiariesToSplit([...selectedBeneficiaries, item])
      })
    }
    setBeneficiaryListVisible(false)
  }
  return (
    <Box
      flexDirection={'row'}
      align={'center'}
      justify={'space-between'}
      ph={16}
      pv={10}
      onPress={onItemPress}
      testID="split-item"
      underlayColor={'TRANSPARENT'}>
      <Box f={1.4}>
        <Text title={item.name} fontFamily={'jiotype-medium'} fontSize={12} numberOfLines={1} />
      </Box>
      <Box flexDirection={'row'} gap={8} f={0.8}>
        <Icon id={'LANDLINE'} size={12} color={'PRIMARY_GREY'} />
        <Text title={item.mobile} fontFamily={'jiotype-medium'} fontSize={12} />
      </Box>
      <Box
        borderRadius={4}
        borderWidth={1}
        pv={4}
        ph={12}
        bg={'#FAFAFA' as ColorOptions}
        borderColor={'#CCCCCC33' as ColorOptions}
        align={'center'}
        justify={'center'}
        f={0.8}>
        <Text title={item?.userType} fontFamily={'jiotype-medium'} fontSize={12} />
      </Box>
    </Box>
  )
}
const keyExtractor = (itemData: any): string => {
  return itemData.id
}
const RenderBeneficiaries = ({
  data,
  setBeneficiaryListVisible,
  setSelectedBeneficiariesToSplit,
  selectedBeneficiaries,
  startTransition,
}) => {
  return (
    <Box
      w={590}
      maxHeight={220}
      minHeight={36}
      overflow={'auto'}
      bg={'WHITE'}
      position={'absolute'}
      zIndex={99999}
      top={210}
      shadowType={'shadowPrimary'}
      shadowColor={'PRIMARY_GREY'}
      shadowOpacity={0.5}
      borderRadius={4}
      borderWidth={1}
      nativeID={'showListScrollBar'}
      borderColor={'#70707000' as ColorOptions}>
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        hide={false}
        isCustom={true}
        testID={'searchBeneResultList'}
        ListContent={data ?? []}
        RenderCustomElement={({ item }) => (
          <RenderItem
            item={item}
            setBeneficiaryListVisible={setBeneficiaryListVisible}
            setSelectedBeneficiariesToSplit={setSelectedBeneficiariesToSplit}
            selectedBeneficiaries={selectedBeneficiaries}
            startTransition={startTransition}
          />
        )}
        keyExtractor={keyExtractor}
      />
    </Box>
  )
}

const RenderSelectedBeneficiaries = ({ item, index, data, selectedBeneficiaries, setSelectedBeneficiariesToSplit }) => {
  const settlmentGrossAmount = +data?.essSettlementGrossAmount

  const onPercentChange = (val: string) => {
    const filteredVal = val.replace(/[^0-9\.]/g, '')
    const splitPercent = Number(filteredVal)
    if (splitPercent <= 100) {
      if (filteredVal?.split('.')?.length === 1 || filteredVal?.split('.')?.[1]?.length <= 2) {
        const updatedSelectedBeneficiaries = selectedBeneficiaries?.map((obj) => {
          if (obj === item) {
            obj.splitPercentage = filteredVal
            obj.splitAmount = +((splitPercent * settlmentGrossAmount) / 100).toFixed(2)
          }
          return obj
        })
        setSelectedBeneficiariesToSplit(updatedSelectedBeneficiaries)
      }
    }
  }

  const onAmountChange = (val: string) => {
    const filteredVal = val.replace(/[^0-9\.]/g, '')
    const splitAmt = Number(filteredVal)
    if (splitAmt <= settlmentGrossAmount) {
      if (filteredVal?.split('.')?.length === 1 || filteredVal?.split('.')?.[1]?.length <= 2) {
        const updatedSelectedBeneficiaries = selectedBeneficiaries?.map((obj) => {
          if (obj === item) {
            obj.splitAmount = filteredVal
            obj.splitPercentage = +((splitAmt * 100) / settlmentGrossAmount).toFixed(2)
          }
          return obj
        })
        setSelectedBeneficiariesToSplit(updatedSelectedBeneficiaries)
      }
    }
  }

  const removeBeneficiary = () => {
    const newBenificiaries = selectedBeneficiaries?.filter((obj) => {
      return obj?.id !== item?.id
    })
    setSelectedBeneficiariesToSplit(newBenificiaries)
  }
  return (
    <Box flexDirection={'row'} align={'flex-start'} mt={10} mr={10}>
      <Box f={0.47} pv={6}>
        <Box pl={14}>
          <Text title={item?.name} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK'} />
          <Text
            title={`${item.mobile} | ${item.userType}`}
            fontFamily={'jiotype-medium'}
            fontSize={8}
            color={'PRIMARY_GREY'}
          />
        </Box>
      </Box>
      <Box f={0.32}>
        <Box mr={16}>
          <TextInputNew
            value={selectedBeneficiaries?.[index]?.splitAmount === 0 ? '' : selectedBeneficiaries?.[index]?.splitAmount}
            bgColor={'WHITE'}
            borderColor={'DISABLED_GREY'}
            paddingHorizontal={14}
            paddingVertical={13}
            borderRadius={4}
            fontSize={12}
            fontWeight={'600'}
            autoFocus={false}
            touched
            onChangeText={onAmountChange}
            leftComponent={<Text title={'₹ '} fontSize={12} color={'BLACK'} fontFamily={'jiotype-medium'} />}
          />
        </Box>
      </Box>
      <Box f={0.16}>
        <TextInputNew
          value={
            selectedBeneficiaries?.[index]?.splitPercentage === 0 ? '' : selectedBeneficiaries?.[index]?.splitPercentage
          }
          onChangeText={onPercentChange}
          bgColor={'WHITE'}
          borderColor={'DISABLED_GREY'}
          paddingHorizontal={14}
          paddingVertical={13}
          borderRadius={4}
          fontSize={12}
          fontWeight={'600'}
          autoFocus={false}
          rightComponent={<Text title={'%'} fontSize={12} color={'BLACK'} fontFamily={'jiotype-medium'} />}
        />
      </Box>
      <Box
        f={0.05}
        align={'flex-end'}
        justify={'center'}
        alignSelf={'center'}
        testID="remove-beneficiary"
        onPress={removeBeneficiary}
        underlayColor={'TRANSPARENT'}>
        <Icon id={'CLOSE'} color={'BLACK'} size={12} />
      </Box>
    </Box>
  )
}
export const CreateSplitSettlement = ({ visible, data, close, refundId = '' }) => {
  const [searchText, setSearchText] = useState('')
  const [beneficiaryListVisible, setBeneficiaryListVisible] = useState(false)
  const [isPending, startTransition] = useTransition()
  const [selectedBeneficiariesToSplit, setSelectedBeneficiariesToSplit] = useState([])

  const { createSplitSettlement, fetchAllBeneficiaries, mid, getAllBeneficieries, setMessage } = useStores((store) => ({
    createSplitSettlement: store.transactions.createSplitSettlements,
    fetchAllBeneficiaries: store.beneficiaryOnboarding.fetchAllBeneficiaries,
    mid: store?.user?.selectedMid,
    getAllBeneficieries: store.beneficiaryOnboarding.getSplitBeneficiaries,
    setMessage: store?.response?.setMessage,
  }))

  const beneficiaryListArr = getAllBeneficieries()
  const [beneficiaryList, setBeneList] = useState(beneficiaryListArr)

  const [lazyFetchAllBeneficiaries, { state }] = useLazyApiData(fetchAllBeneficiaries)
  const [lazyCreateSplitSettlementApi, { state: createApiState }] = useLazyApiData(createSplitSettlement)

  useEffect(() => {
    visible && lazyFetchAllBeneficiaries(mid, '101', 1, 1500)
  }, [visible])

  useEffect(() => {
    if (state === 'fulfilled' && beneficiaryListArr?.length === 0) {
      setMessage('No Beneficiaries found to split')
    }
    if (
      (state === 'fulfilled' && beneficiaryListArr?.length === 0) ||
      state === 'rejected' ||
      createApiState === 'fulfilled' ||
      createApiState === 'rejected'
    ) {
      close()
    }
  }, [state, createApiState])
  const onChange = (val: string) => {
    setSearchText(val)
    const filteredBeneList = beneficiaryListArr?.filter(
      (item) =>
        isEmpty(val) ||
        item?.name?.toLowerCase().includes(val.toLowerCase()) ||
        item?.mobile.includes(val) ||
        item.id.includes(val) ||
        item?.emailId.includes(val?.toLowerCase()),
    )
    setBeneList(filteredBeneList)
  }

  const txnAmount = isEmpty(refundId) ? +data?.details?.amount?.replaceAll(',', '') : +data?.refundAmount

  const settlmentGrossAmount = +data?.essSettlementGrossAmount
  const isCreateDisabled = () => {
    let totalSplittedAmount = 0
    let totalSplittedPercent = 0
    let amountInvalid = []
    selectedBeneficiariesToSplit?.map((item) => {
      if (+item?.splitAmount > 0 && +item?.splitPercentage > 0) {
        totalSplittedAmount = +item?.splitAmount + totalSplittedAmount
        totalSplittedPercent = +item?.splitPercentage + totalSplittedPercent
      } else {
        amountInvalid.push(0)
      }
    })
    return (
      amountInvalid?.length > 0 ||
      totalSplittedAmount <= 0 ||
      totalSplittedAmount > settlmentGrossAmount ||
      totalSplittedPercent <= 0 ||
      totalSplittedPercent > 100
    )
  }
  const disabled = isCreateDisabled()

  const onPress = () => {
    if (!disabled) {
      lazyCreateSplitSettlementApi(
        isEmpty(refundId) ? data?.details?.originalTransactionId : refundId,
        data?.paymentDetails?.paymentMode,
        settlmentGrossAmount,
        +Number(settlmentGrossAmount - getConsumedAmount(selectedBeneficiariesToSplit))?.toFixed(2),
        selectedBeneficiariesToSplit,
      )
    } else {
      setMessage('Please enter valid amount')
    }
  }

  const getData = () => {
    const listData = searchText?.length === 0 && beneficiaryListArr?.length > 0 ? beneficiaryListArr : beneficiaryList
    return listData?.filter((item) => {
      const selectedItemInAllBeneficiaries = selectedBeneficiariesToSplit?.find((obj) => item?.id === obj?.id)
      return !selectedItemInAllBeneficiaries
    })
  }
  return (
    <ModalDialog show={visible} type={'CenteredWrap'}>
      <>
        <ModBox
          show={state === 'pending'}
          bg={'WHITE'}
          borderRadius={8}
          w={690}
          h={420}
          align={'center'}
          justify={'center'}>
          <Loader type={'large'} />
        </ModBox>
        <ModBox
          bg={'WHITE'}
          show={beneficiaryListArr?.length > 0 && state !== 'pending'}
          borderRadius={8}
          ph={20}
          pt={22}
          pb={28}
          onPress={() => setBeneficiaryListVisible(false)}
          underlayColor={'WHITE'}>
          <Box flexDirection={'row'} align={'center'} justify={'space-between'}>
            <Text
              title={'Split Settlement'}
              fontFamily={'jiotype-bold'}
              fontSize={18}
              lineHeight={23}
              color={'#202F4D' as ColorOptions}
              />
            <IconButton
              id={'CLOSE'}
              testID="close-beneficiary"
              size={16}
              color={'BLACK_21'}
              onPress={() => [setBeneficiaryListVisible(false), close()]}
            />
          </Box>
          <Spacer direction="vertical" size={40} />
          <Box ph={30}>
            <Box flexDirection={'row'} align={'center'} justify={'space-between'} gap={24}>
              <Box>
                <Text title={'Transaction Amount'} fontFamily={'jiotype-bold'} fontSize={12} color={'BLACK_21'} />
                <Spacer direction="vertical" size={6} />
                <Box
                  borderWidth={1}
                  borderRadius={4}
                  borderColor={'#CCCCCC33' as ColorOptions}
                  justify={'center'}
                  h={32}
                  ph={12}
                  w={180}
                  bg={'LIGHT_GREY_SEPARATOR'}>
                  <Text
                    title={isNaN(txnAmount) || txnAmount < 0 ? '₹ 0' : `₹ ${txnAmount}`}
                    fontFamily={'jiotype-medium'}
                    fontSize={12}
                    color={'BLACK_21'}
                  />
                </Box>
              </Box>
              <Box>
                <Text title={'Settlement Amount'} fontFamily={'jiotype-bold'} fontSize={12} color={'BLACK_21'} />
                <Spacer direction="vertical" size={6} />
                <Box
                  borderWidth={1}
                  borderRadius={4}
                  borderColor={'#CCCCCC33' as ColorOptions}
                  justify={'center'}
                  h={32}
                  ph={12}
                  w={180}
                  bg={'LIGHT_GREY_SEPARATOR'}>
                  <Text
                    title={`₹ ${settlmentGrossAmount}`}
                    fontFamily={'jiotype-medium'}
                    fontSize={12}
                    color={'BLACK_21'}
                  />
                </Box>
              </Box>
              <Box>
                <Text title={'Transaction ID'} fontFamily={'jiotype-bold'} fontSize={12} color={'BLACK_21'} />
                <Spacer direction="vertical" size={6} />
                <Box
                  borderWidth={1}
                  borderRadius={4}
                  justify={'center'}
                  borderColor={'#CCCCCC33' as ColorOptions}
                  h={32}
                  ph={12}
                  w={180}
                  bg={'LIGHT_GREY_SEPARATOR'}>
                  <Text
                    title={isEmpty(refundId) ? `#${data?.details?.originalTransactionId}` : refundId}
                    fontFamily={'jiotype-medium'}
                    fontSize={12}
                    color={'BLACK_21'}
                  />
                </Box>
              </Box>
            </Box>
            <Spacer direction="vertical" size={24} />
            <Box>
              <Text title={'Platform Fee'} fontFamily={'jiotype-bold'} fontSize={12} color={'BLACK_21'} />
              <Spacer direction="vertical" size={6} />
              <Box
                borderWidth={1}
                borderRadius={4}
                borderColor={'#CCCCCC33' as ColorOptions}
                justify={'center'}
                h={32}
                ph={12}
                w={180}
                bg={'LIGHT_GREY_SEPARATOR'}>
                <Text
                  title={
                    Number(settlmentGrossAmount - getConsumedAmount(selectedBeneficiariesToSplit)) <= 0
                      ? '₹ 0'
                      : `₹ ${Number(settlmentGrossAmount - getConsumedAmount(selectedBeneficiariesToSplit))?.toFixed(
                        2,
                      )}`
                  }
                  fontFamily={'jiotype-medium'}
                  fontSize={12}
                  color={'BLACK_21'}
                />
              </Box>
            </Box>
            <Spacer direction="vertical" size={24} />
            <Text
              title={'Select Beneficiary for the split'}
              fontFamily={'jiotype-bold'}
              fontSize={12}
              color={'BLACK_21'}
            />
            <Spacer direction="vertical" size={6} />
            <TextInputNew
              value={searchText}
              leftComponent={<Icon id={'SEARCH'} color={'PRIMARY_GREY'} />}
              borderColor={'#CCCCCC99' as ColorOptions}
              paddingHorizontal={16}
              paddingVertical={9}
              borderRadius={4}
              placeholder={'Enter name, phone number, email id or beneficiary id'}
              placeholderTextColor={'PRIMARY_GREY'}
              color={'BLACK_21'}
              fontSize={12}
              fontWeight={'500'}
              textWidth={535}
              onChangeText={onChange}
              onFocus={() => setBeneficiaryListVisible(selectedBeneficiariesToSplit?.length < 10)}
            />
            {state === 'pending' && <Loader />}

            {beneficiaryListVisible && getData()?.length > 0 && (
              <RenderBeneficiaries
                data={getData()}
                setBeneficiaryListVisible={setBeneficiaryListVisible}
                setSelectedBeneficiariesToSplit={setSelectedBeneficiariesToSplit}
                selectedBeneficiaries={selectedBeneficiariesToSplit}
                startTransition={startTransition}
              />
            )}
            <ModBox
              borderRadius={6}
              bg={'GRAY_HALF'}
              pv={14}
              ph={16}
              mt={18}
              show={selectedBeneficiariesToSplit?.length > 0}>
              <Box maxHeight={212} overflow={'auto'} nativeID={'showListScrollBar'}>
                <ModBox flexDirection={'row'} align={'center'} show={selectedBeneficiariesToSplit?.length > 0}>
                  <Box f={0.5}>
                    <Text title={'Beneficiary'} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK'} />
                  </Box>
                  <Box f={0.3}>
                    <Text title={'Amount'} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK'} />
                  </Box>
                  <Box f={0.15}>
                    <Text title={'Percentage'} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK'} />
                  </Box>
                  <Box f={0.05} />
                </ModBox>
                <TableComponent
                  value={''} //Routes value
                  canFetchMore={false}
                  hide={selectedBeneficiariesToSplit?.length === 0}
                  isCustom={true}
                  testID={'selectedBeneList'}
                  ListContent={selectedBeneficiariesToSplit ?? []}
                  RenderCustomElement={({ item, index }) => (
                    <RenderSelectedBeneficiaries
                      item={item}
                      index={index}
                      data={data}
                      selectedBeneficiaries={selectedBeneficiariesToSplit}
                      setSelectedBeneficiariesToSplit={setSelectedBeneficiariesToSplit}
                    />
                  )}
                  keyExtractor={keyExtractor}
                />
              </Box>
            </ModBox>
            <Spacer direction="vertical" size={50} />
            <Box
              h={40}
              w={218}
              borderRadius={4}
              bg={Colors.REPORT_PRIMARY as ColorOptions}
              align={'center'}
              justify={'center'}
              disabled={selectedBeneficiariesToSplit?.length === 0 || disabled || createApiState === 'pending'}
              opacity={selectedBeneficiariesToSplit?.length === 0 || disabled || createApiState === 'pending' ? 0.5 : 1}
              alignSelf={'flex-end'}
              underlayColor={'TRANSPARENT'}
              testID="create-split"
              onPress={onPress}>
              <Text
                title={'Create Split Settlement'}
                fontFamily={'jiotype-medium'}
                fontSize={14}
                color={'WHITE'}
                hide={createApiState === 'pending'}
                lineHeight={20}
              />
              {createApiState === 'pending' && <Loader color="WHITE" />}
            </Box>
          </Box>
        </ModBox>
      </>
    </ModalDialog>
  )
}
